module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/en_5-8e32ea7bc0deae0abae172e22d37adf2.jpg";